import { render } from "./NewReceptionModal.vue?vue&type=template&id=019b0e07"
import script from "./NewReceptionModal.vue?vue&type=script&lang=js"
export * from "./NewReceptionModal.vue?vue&type=script&lang=js"

import "./NewReceptionModal.vue?vue&type=style&index=0&id=019b0e07&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__